import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useOpportunitiesStore } from "../../store/opportunities.store";
import { useCompanyStore } from "../../store/company.store";

export const useCompanyPersons = () => {
  const setPersons = useCompanyStore((state) => state.setPersons);

  return useMutation(PartnerApi.companyPersons, {
    onSuccess: (data) => {
      setPersons(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
export const useCompany = () => {
  const setCompany = useCompanyStore((state) => state.setCompany);

  return useMutation(PartnerApi.company, {
    onSuccess: (data) => {
      setCompany(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useCompanyList = () => {
  const setCompanyList = useCompanyStore((state) => state.setCompanyList);

  return useMutation(PartnerApi.companyList, {
    onSuccess: (data) => {
      setCompanyList(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
